module.exports = __webpack_public_path__ + "static/media/carousel-1-origin.09c36c79.jpg";